import { checkProductLimit, countExcelRows } from "../../../utils/planLimits";
import React, { useEffect, useState } from "react";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import { uploadExcelFile } from "../../../services/Societe";
import { useLocation } from 'react-router-dom';
import getCurrentUserId from "../../../reduxSaga/sagas/requests/currentUserId";
import api from "../../../services/api";
import { ToastContainer, toast } from "react-toastify";
import withLoader from "../../../components/layouts/WithLoader";
const headersMap = {
  tiers: [
    [
      "Matricule",
      "Titre",
      "NBR E.Secondaires",
      "Timbre",
      "Email",
      "Téléphone",
      "Adresse",
      "Code Catégorie (M,P,C)",
      "Code TVA",
      "Type Societe (Normale, Exportatrice)",
      "TVA %",
      "Type (Fournisseur / Client)",
      "Code (facultatif, - si aucun)",
    ],
  ],
  families: [
    [
      "familyName",
      "description",
      "type 1 PRODUIT 2 SERVICE",
      "sku",
    ],
  ],
  subFamilies: [
    [
      "libelle",
      "description",
      "libelle famille",
    ],
  ],
  categories: [
    [
      "name",
      "description",
      "sku",
      "subfamily-name",
    ],
  ],
  brands: [
    [
      "name",
      "description",
    ],
  ],
  products: [
    [
      "Libellé",
      "description (séparer les lignes par ' - ')",
      "Code article",
      "Code à barre",
      "TVA",
      "type-produit(1 produit/2service)",
      "Famille",
      "Sous-famille",
      "Catégorie",
      "Marque",
      "Libellé anglais (facultatif)",
      "Description anglais (facultatif)",
    ],
  ],
};
const UploadExcel = ({ startLoading, stopLoading }) => {
  const [uploadedData, setUploadedData] = useState(null); // Track file
  const [isUploading, setIsUploading] = useState(false); // Track upload state
  const [headers, setHeaders] = useState([]); // Track upload state

  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const type = searchParams.get('type');  // Get the 'type' query parameter
  useEffect(() => {
    if (type && headersMap[type]) {
      setHeaders(headersMap[type]);
    }
    console.log(type);
  }, [type]);
  // Function to download the model Excel
  const onTelechargerModel = () => {
    const workbook = XLSX.utils.book_new();
    const worksheet = XLSX.utils.aoa_to_sheet(headers);

    // Add green background styling to headers
    const range = XLSX.utils.decode_range(worksheet["!ref"]);
    for (let C = range.s.c; C <= range.e.c; ++C) {
      const cellAddress = XLSX.utils.encode_cell({ r: 0, c: C });
      if (!worksheet[cellAddress]) continue;
      worksheet[cellAddress].s = {
        fill: { fgColor: { rgb: "00FF00" } }, // Green background
        font: { bold: true, color: { rgb: "000000" } }, // Black bold text
      };
    }

    // Append worksheet to workbook
    XLSX.utils.book_append_sheet(workbook, worksheet, "Model");

    // Save file as a downloadable Excel file
    const fileBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
    saveAs(new Blob([fileBuffer], { type: "application/octet-stream" }), "model.xlsx");
  };

  // Handle file upload
  const handleFileUpload = (e) => {
    const file = e.target.files[0]; // Get the first file from the input
    if (file) {
      setUploadedData(file); // Store the file in state
    }
  };

  // Upload the Excel file to the server
  const uploadExcelFileToServer = (file) => {
    const formData = new FormData();
    formData.append("file", file);

    const endpoints = {
      tiers: `/retail/SocieteRestApi/addSocieteExcel/${getCurrentUserId()}`,
      families: `/retail/product/addProductFamilyExcel/${getCurrentUserId()}`,
      subFamilies: `/retail/product/addProductSubFamilyExcel/${getCurrentUserId()}`,
      categories: `/retail/product/addProductCategoryExcel/${getCurrentUserId()}`,
      brands: `/retail/product/addProductBrandExcel/${getCurrentUserId()}`,
      products: `/retail/product/addProductExcelAuto/${getCurrentUserId()}`,
    };
    startLoading();
    if (type && endpoints[type]) {
      return api
        .post(endpoints[type], formData, {
          headers: {
            "Content-Type": "multipart/form-data",
            Accept: "application/json",
          },
        })
        .then((response) => {
          stopLoading();
          const result = response.data || {};
          if (result.status === "error") {
            toast.error(result.message || "Erreur lors de l'importation");
            return;
          }
          if (type !== "products") {
            toast.success("Fichier téléchargé avec succès");
            return;
          }
          const exist = result.exist || [];
          const errors = result.errors || [];
          toast.success(`${result.created || 0} produit(s) créé(s)`);
          if (exist.length > 0) {
            toast.warn(`${exist.length} produit(s) déjà existant(s) ignoré(s) : ${exist.slice(0, 5).join(", ")}${exist.length > 5 ? "..." : ""}`);
          }
          if (errors.length > 0) {
            toast.error(`${errors.length} ligne(s) en erreur : ${errors.slice(0, 3).map((e) => `${e.row} (${e.message})`).join(" ; ")}${errors.length > 3 ? "..." : ""}`, { autoClose: false });
          }
        })
        .catch((error) => {
          stopLoading();
          toast.error("Erreur lors du téléchargement du fichier");
          throw error;
        });
    } else {
      toast.error("Type non pris en charge pour le téléchargement");
      stopLoading();
      return Promise.reject(new Error("Unsupported type for upload"));
      
    }
  };


  // Handle adding the uploaded file
  const handleAjouter = () => {
    if (uploadedData && !isUploading) {
      setIsUploading(true); // Set uploading state to true
      const checkLimit =
        type === "products"
          ? countExcelRows(uploadedData)
              .catch(() => 1)
              .then((rows) => checkProductLimit(Math.max(rows, 1)))
          : Promise.resolve({ allowed: true });
      checkLimit
        .then((limit) => {
          if (!limit.allowed) {
            toast.error(limit.message);
            return Promise.reject(new Error("plan limit"));
          }
          return uploadExcelFileToServer(uploadedData);
        })
        .then((response) => {
          console.log("Upload successful", response);
        })
        .catch((error) => {
          console.error("Upload error", error);
        })
        .finally(() => {
          setIsUploading(false); // Reset uploading state after process finishes
        });
    } else {
      console.error("No file selected for upload or upload already in progress.");
    }
  };

  return (
    <div className="content-wrapper" style={{ marginTop: "0" }}>
      <ToastContainer />
      <section className="content-header">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-6"></div>
            <div className="col-md-6">
              <ol className="breadcrumb float-sm-right">
                <li className="breadcrumb-item">Home</li>
                <li className="breadcrumb-item active">Ajouter {type}</li>
              </ol>
            </div>
          </div>
        </div>
      </section>
      <section className="content">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-12">
              <div className="card card-dark">
                <div className="card-footer">
                  <h3>Ajouter la liste des {type}</h3>
                </div>
                <div className="p-3 d-flex justify-content-between align-items-center">
                  <h4>Télécharger le Model Excel</h4>
                  <button className="btn btn-dark float-right" onClick={onTelechargerModel}>
                    <i className="fas fa-download"></i> Télécharger model Excel
                  </button>
                </div>
                <div className="card-body">
                  <p>Si la valeur de la colonne n'est pas présente merci de mettre -</p>
                  {type === "products" && (
                    <p>
                      Famille, sous-famille, catégorie et marque sont créées automatiquement si elles n'existent pas.
                      Les produits sont créés en achat, en vente, produit fini et matière première.
                      Dans les descriptions, chaque " - " (tiret entouré d'espaces) crée un retour à la ligne.
                      Le libellé et la description en anglais sont facultatifs.
                    </p>
                  )}
                </div>
                <div className="p-3 d-flex justify-content-between align-items-center">
                  <input
                    type="file"
                    accept=".xlsx, .xls"
                    className="btn btn-dark float-right"
                    onChange={handleFileUpload} // Handle file selection
                  />
                  <button
                    className="btn btn-dark float-end"
                    onClick={handleAjouter} // Upload file
                    title="Ajouter cette liste"
                    aria-label="Ajouter cette liste"
                    disabled={isUploading} // Disable button while uploading
                  >
                    <i className="fas fa-location-arrow" aria-hidden="true"></i> Ajouter cette liste
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default withLoader(UploadExcel);
